<template>
  <div class="empty-container">
    <img class="empty-icon" src="@/assets/images/icon-over.png" alt="" />
    <div class="empty-text">报名已截止！</div>
  </div>
</template>
<script>
export default {
  name: "FormStatus",
  data() {
    return {};
  },
};
</script>
